import { RecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useBaseActions } from '../base.actions';
import { acaosAtom } from './AcaoState';
import { useAxiosWrapper } from '../../services/axiosWrapper';
import { authAtom } from './../usuarios/AuthState';
import { history } from '../../helpers/history';


function useAcoesActions() {
  const baseActions = useBaseActions('Acoes', acaosAtom, false);
  const axiosWrapper = useAxiosWrapper();
  const authState = useRecoilValue(authAtom);
  const setAuth = useSetRecoilState(authAtom);


  return {
    list,
    listConfig,
    get: baseActions.get,
    create: baseActions.create,
    update: baseActions.update,
    delete: baseActions.delete,
  };

  async function list() {
    let url = `${process.env.REACT_APP_API_URL}/v1/assessorados/acoes`;

    try {
      const recursos = await axiosWrapper.get(url + `?contatoId=${authState?.id}`);

      return recursos;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }

  }

  async function listConfig() {
    let url = `${process.env.REACT_APP_API_URL}/v1/assessorados/configAcoes`;

    try {
      const recursos = await axiosWrapper.get(url);

      return recursos;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }

  }
}

export { useAcoesActions };
